import React from 'react';

import { AuthContextType, StorageContextType } from './types';

const AuthContext = React.createContext<AuthContextType>(null!);
const StorageContext = React.createContext<StorageContextType>(null!);
const CookieManagementContext = React.createContext(false);

const Contexts = {
  AuthContext,
  StorageContext,
  CookieManagementContext,
};

export default Contexts;
